export default __webpack_public_path__ + "static/media/3080.000710f4.png";